import { matchPath } from "react-router-dom-v5-compat";
import type { SupportContext } from "@b2bportal/rbc-hts-assist-api";
import { PATH_TRIPS } from "@hopper-b2b/utilities";

// Trips detail-route product segment -> the HTS Assist productType the agent
// resolves bookings by. flight | hotel | car | home match the values
// commerce-portals sends on its SupportContext; package is additional here.
const PRODUCT_TYPE_BY_ROUTE_SEGMENT: Record<
  string,
  SupportContext["productType"]
> = {
  flights: "flight",
  hotels: "hotel",
  cars: "car",
  homes: "home",
  packages: "package",
  activities: "activity",
};

/**
 * Derives the focused-booking SupportContext from a trips detail route
 * (`trips/{flights|hotels|cars|homes|packages|activities}/:reservationId`). The
 * `:reservationId` path param is the per-product reservation id (the flight
 * itinerary id, hotel reservationBookingId, the package's `hopperReservationId`
 * etc.) -- the same id commerce-portals sends and the id the agent looks the
 * booking up by, NOT the trip/order id. Returns undefined on the trips list and
 * every other surface so Assist opens generic there.
 */
export const pathnameToSupportContext = (
  pathname: string
): SupportContext | undefined => {
  const match = matchPath(
    { path: `${PATH_TRIPS}:productSegment/:reservationId`, end: false },
    pathname
  );

  const productSegment = match?.params.productSegment;
  const reservationId = match?.params.reservationId;
  if (!productSegment || !reservationId) return undefined;

  const productType = PRODUCT_TYPE_BY_ROUTE_SEGMENT[productSegment];
  if (!productType) return undefined;

  return { bookingId: reservationId, productType };
};
